<template>
	<div>
		<div v-for="(row, idx) in rows" :key="idx" class="d-flex mb-1">
			<b-input class="mr-1" style="flex: 0 0 40%" placeholder="Key" :value="row.k" :disabled="disabled" @input="v => update(idx, 'k', v)"></b-input>
			<b-input class="mr-1" placeholder="Value" :value="row.v" :disabled="disabled" @input="v => update(idx, 'v', v)"></b-input>
			<b-button variant="outline-danger" size="sm" :disabled="disabled" @click="remove(idx)"><b-icon icon="x"></b-icon></b-button>
		</div>
		<b-button variant="outline-secondary" size="sm" :disabled="disabled" @click="add"><b-icon icon="plus"></b-icon> Add</b-button>
	</div>
</template>

<script>
// v-model is a plain JSON object { key: value }. Kept as internal rows so keys can be edited freely.
export default {
	name: 'KeyValueList',
	props: {
		value: { type: Object, default: null },
		disabled: { type: Boolean, default: false },
	},
	data() { return { rows: [] }; },
	created() { this.syncFromValue(this.value); },
	watch: {
		value(nv) {
			if(JSON.stringify(this.toObject(this.rows)) !== JSON.stringify(nv || {}))
				this.syncFromValue(nv);
		},
	},
	methods: {
		syncFromValue(v) {
			this.rows = Object.entries(v || {}).map(([k, val]) => ({ k, v: val }));
		},
		toObject(rows) {
			const o = {};
			for(const r of rows) if(r.k) o[r.k] = r.v;
			return o;
		},
		emitChange() { this.$emit('input', this.toObject(this.rows)); },
		add() { this.rows.push({ k: '', v: '' }); this.emitChange(); },
		remove(idx) { this.rows.splice(idx, 1); this.emitChange(); },
		update(idx, key, val) { this.$set(this.rows[idx], key, val); this.emitChange(); },
	},
};
</script>
